export default function (listing) {
  // UGA
  dataLayer.push({
    event: "addToCart",
    ecommerce: {
      add: {
        products: [
          {
            name: listing.title,
            id: listing.id,
            price: parseInt(listing.total.dollars),
            brand: listing.artist.full_name,
            quantity: 1,
          },
        ],
      },
    },
  })
  // GA4
  dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
  dataLayer.push({
    event: "add_to_cart",
    ecommerce: {
      currency: "AUD",
      value: parseInt(listing.total.dollars),
      items: [
        {
          item_id: listing.id,
          item_name: listing.title,
          item_brand: listing.artist.full_name,
          quantity: 1,
        },
      ],
    },
  })
}
